import { IconButton, TextField } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { MoneyMaskedInput2 } from "../../../../../../common/components/masked_inputs/money_masked_input2";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

type Props = {
  OnActionValorChange(idChecklistServicoEmpreendimento: number, newValue: number | null): void;
  OnActionQuantidadeChange(idChecklistServicoEmpreendimento: number, newValue: number | null,): void;
  onActionEditar(idChecklistServicoEmpreendimento: number, openNewTab: boolean): void;
  onActionDelete(idChecklistServicoEmpreendimento: number, openModal: boolean): void;
};
export const GenerateChecklistServicoEmpreendimentoColumns = ({
  OnActionValorChange,
  OnActionQuantidadeChange,
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricaoServico",
      filterable: false,
      headerName: "Produto",
      flex: 1,
      minWidth: 350,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "unidade",
      filterable: false,
      headerName: "Unidade de Medida",
      minWidth: 110,
      width: 110,
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
            <span>{params.value}</span>
          </div>
        );
      },
    },
    {
      field: "Quantidade",
      filterable: false,
      minWidth: 150,
      width: 150,
      headerName: "Quantidade Prevista por unidade",
      sortable: false,
      renderCell: (params) => {
        const id = params.row['idChecklistServicoEmpreendimento'] as number;
        const quantidade = params.row['quantidade'] as number;
        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <TextField
              size="small"
              fullWidth
              type="number"
              variant="outlined"
              value={quantidade ?? ""}
              onChange={(e) => {
                const valor = e.target.value ? Number(e.target.value) : null;
                OnActionQuantidadeChange(id, valor);
              }}
            />
          </div>
        );
      },
    },
    {
      field: "valorUnitario",
      filterable: false,
      minWidth: 180,
      width: 180,
      headerAlign: "center",
      headerName: "Valor Unitário",
      sortable: false,
      renderCell: (params) => {
        const id = params.row['idChecklistServicoEmpreendimento'] as number;
        const value = params.row['valorUnitario'] as number;

        return (
          <div className="w-full flex items-center justify-center h-full p-1">
            <MoneyMaskedInput2
              name="ValorUnitario"
              label=""
              readOnly={false}
              value={value == null ? "" : value.toString()}
              onChange={(novoValor) => {
                OnActionValorChange(id, Number(novoValor));
              }}
            />
          </div>
        );
      },
    },
    {
      field: "idChecklistServicoEmpreendimento",
      filterable: false,
      minWidth: 180,
      width: 180,
      headerAlign: "center",
      headerName: "Ações",
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                if (e.button === 1) {
                  onActionEditar(value, true);
                } else {
                  onActionEditar(value, e.ctrlKey);
                }
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true); }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
};
